import { render, staticRenderFns } from "./UsersDataTable.vue?vue&type=template&id=3d2b18fa&scoped=true"
import script from "./UsersDataTable.vue?vue&type=script&lang=js"
export * from "./UsersDataTable.vue?vue&type=script&lang=js"
import style0 from "./UsersDataTable.vue?vue&type=style&index=0&id=3d2b18fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2b18fa",
  null
  
)

export default component.exports